var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRefreshRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4842 7.00022H14.7498C15.1654 7.00022 15.4998 6.66585 15.4998 6.25022V2.25022C15.4998 1.9471 15.3186 1.6721 15.0373 1.55647C14.7561 1.44085 14.4342 1.50335 14.2186 1.71897L12.9186 3.01897C10.1811 0.315849 5.77168 0.325224 3.0498 3.05022C0.31543 5.7846 0.31543 10.2158 3.0498 12.9502C5.78418 15.6846 10.2154 15.6846 12.9498 12.9502C13.3404 12.5596 13.3404 11.9252 12.9498 11.5346C12.5592 11.144 11.9248 11.144 11.5342 11.5346C9.58105 13.4877 6.41543 13.4877 4.4623 11.5346C2.50918 9.58147 2.50918 6.41585 4.4623 4.46272C6.40605 2.51897 9.54668 2.5096 11.5029 4.43147L10.2186 5.71897C10.0029 5.9346 9.94043 6.25647 10.0561 6.53772C10.1717 6.81897 10.4467 7.00022 10.7498 7.00022H14.4842Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefreshRed);
export default __webpack_public_path__ + "static/media/ic_refresh_red.21b18983e8942529617721cf953d78a6.svg";
export { ForwardRef as ReactComponent };